module.exports = __webpack_public_path__ + "static/media/2_pl.1473dc7f.png";